import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { QuoteDetailEffects } from './quote-detail.effects';
import * as fromQuoteDetailState from './quote-detail.reducer';

@NgModule({
	imports: [
		StoreModule.forFeature(
			fromQuoteDetailState.quoteDetailFeatureKey,
			fromQuoteDetailState.reducer
		),
		EffectsModule.forFeature([QuoteDetailEffects]),
	],
})
export class QuoteDetailStateModule {}
